import { cva, type VariantProps } from 'class-variance-authority';

export { default as Input } from './Input.vue';

export const inputVariants = cva(
    'bg-input text-foreground placeholder:text-muted-foreground border min-w-0 rounded-md disabled:pointer-events-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 outline-none focus-visible:ring-[3px] focus-visible:ring-ring aria-invalid:border-destructive-border aria-invalid:focus-visible:ring-ring-error transition-[color,box-shadow]',
    {
        variants: {
            size: {
                xs: 'h-6 px-1.5 text-xs',
                sm: 'h-8 px-2 py-0.5 text-sm',
                default: 'h-9 px-3 py-1 text-sm',
                lg: 'h-10 px-4 py-2 text-sm',
            },
        },
        defaultVariants: {
            size: 'default',
        },
    }
);

export type InputVariants = VariantProps<typeof inputVariants>;
